import createPlugin from './createPlugin'

import { ContainerComponent as Component } from '@peracto/peracto-blocks-tailwind'

import { default as Container } from '@peracto/peracto-blocks-tailwind/dist/layout/Container/Component'

import Form from './Form'

const containerPlugin = settings =>
    createPlugin({
        Component: Container,
        FormComponent: Form,
        ...settings,
    })

const container = containerPlugin()
export default container

export { containerPlugin, Component }
